import { render, staticRenderFns } from "./ClientEditDialog.vue?vue&type=template&id=4170561b&"
import script from "./ClientEditDialog.vue?vue&type=script&lang=js&"
export * from "./ClientEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientEditDialog.vue"
export default component.exports